export default function updateOptionsSelected(
  options: any[],
  setOptions: React.Dispatch<React.SetStateAction<any[]>>,
  value: any
): void {
  if (options.includes(value)) {
    const updatedOptions = options.filter((d) => d !== value);
    setOptions(updatedOptions);
  } else {
    const updatedOptions = [...options, value];
    setOptions(updatedOptions);
  }
}
